<template>
  <component :is="tag" class="text-center m-t-xs m-b-xs">
    <h3 v-if="text" class="m-b-xs">{{ text }}</h3>

    <font-awesome class="text-primary" :icon="['fal', 'circle-notch']" spin :size="size" :style="iconStyle"/>
  </component>
</template>

<script>
export default {
  props: {
    tag: {
      required: false,
      type: String,
      default: 'div'
    },
    size: {
      required: false,
      type: String,
      default: '2x'
    },
    iconStyle: {
      required: false,
      type: Object,
      default: () => {
        return {}
      }
    },
    text: {
      required: false,
      type: String
    }
  }
}
</script>
